'use strict';

var curry = require('./curry.js');
require('./chunk-e6d921c6.js');
var _get = require('./_get.js');

/**
 * Gets a property of an object using a key path.
 *
 * @function
 * @param {Array|String} ks The key path.
 * @param {Object} o The object.
 * @returns The property at the key path `ks` in the object `o`.
 * @example
 *
 * import { get } from 'fkit'
 * const person = { name: 'Jane', age: 20, address: { city: 'Melbourne', country: 'Australia' } }
 * get('name', person) // 'Jane'
 * get('address.city', person) // 'Melbourne'
 */

var get = curry(_get);

module.exports = get;
